/**
 * @todo(sc-16399): remove this file
 */
import React from 'react'
import IconButton from '@mui/material/IconButton'
import MUISnackbar, { SnackbarProps } from '@mui/material/Snackbar'
import SnackbarContent from '@mui/material/SnackbarContent'
import { withStyles } from '~/common/theme'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import CloseIcon from '@mui/icons-material/Close'
import ErrorIcon from '@mui/icons-material/Error'
import InfoIcon from '@mui/icons-material/Info'
import WarningIcon from '@mui/icons-material/Warning'
import classy from 'shared/utils/classy'
import { Portal } from 'react-portal'

import { SIZES, COLORS } from '~/common/globalStyles'

export const VARIANT = {
  success: 'success',
  warning: 'warning',
  error: 'error',
  info: 'info',
}

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
}

const styles1 = (theme: any) => ({
  success: {
    backgroundColor: COLORS.green,
  },
  error: {
    backgroundColor: COLORS.red,
  },
  info: {
    backgroundColor: COLORS.darkGray,
  },
  warning: {
    backgroundColor: COLORS.orange,
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(2),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
    fontSize: SIZES.medium,
    lineHeight: SIZES.large,
  },
  root: {
    display: 'grid !important',
    gridTemplateColumns: 'auto auto',
  },
})

interface MySnackbarContentProps extends SnackbarProps {
  variant: keyof typeof VARIANT
  onClose: () => void
  classes?: Record<string, any>
}

const MySnackbarContent: React.FC<MySnackbarContentProps> = ({
  classes,
  className,
  message,
  onClose,
  variant,
  ...other
}) => {
  const { ref: _ref, ...snackbarContentProps } = other as typeof other & {
    ref?: React.Ref<unknown>
  }
  const Icon = variantIcon[variant]
  const closeButton = (
    <IconButton
      key="close"
      aria-label="Close"
      color="inherit"
      className={classes?.close}
      onClick={onClose}
      size="large"
    >
      <CloseIcon className={classes?.icon} />
    </IconButton>
  )

  return (
    <SnackbarContent
      className={classes && classy(classes[variant], className)}
      classes={{ root: classes?.root }}
      aria-describedby="client-snackbar"
      data-testid="client-snackbar"
      message={
        <span id="client-snackbar" className={classes?.message}>
          <Icon className={classy(classes?.icon, classes?.iconVariant)} />
          {message}
        </span>
      }
      action={closeButton}
      {...snackbarContentProps}
    />
  )
}

const MySnackbarContentWrapper = withStyles(MySnackbarContent, styles1)

const Snackbar: React.FC<MySnackbarContentProps> = ({
  variant,
  open,
  ...props
}) => {
  if (!props.message) return null

  return (
    <Portal>
      <MUISnackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        style={{ marginTop: SIZES.small }}
        open={open}
        {...props}
      >
        <div>
          <MySnackbarContentWrapper
            variant={variant}
            open={open}
            message={props.message}
            onClose={props.onClose}
          />
        </div>
      </MUISnackbar>
    </Portal>
  )
}

Snackbar.defaultProps = {
  variant: VARIANT.info as keyof typeof VARIANT,
  open: true,
}

export default Snackbar
